<template>
	<div class="p-6 space-y-4">
		<h1 class="text-2xl font-semibold text-gray-900">
			{{ __("Change password") }}
		</h1>

		<div class="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-6">
			<ui-input-group
				v-model="form.current_password"
				field="current_password"
				label="Old password"
				type="password"
				:form="form"
				:required="false"
			></ui-input-group>

			<div class="hidden sm:block"></div>

			<ui-input-group
				v-model="form.new_password"
				autocomplete="new-password"
				field="new_password"
				label="New password"
				type="password"
				:form="form"
				:required="false"
			></ui-input-group>

			<ui-input-group
				v-model="form.new_password_confirmation"
				field="new_password_confirmation"
				label="Password confirmation"
				type="password"
				:form="form"
				:required="false"
			></ui-input-group>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
	},
};
</script>
